(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["signup-popup"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-signup]');
    if (!root) return;
    const KEY = 'dutturi:signup';
    const days = Number(root.dataset.days || 30);
    const store = {
      get() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } },
      set(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
    };
    let lastFocus = null;
    const open = () => {
      if (!root.hidden) return;
      lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      const f = root.querySelector('input[type=email], [data-signup-copy], a.btn');
      if (f) f.focus({ preventScroll: true });
    };
    const close = () => {
      root.hidden = true;
      document.documentElement.style.overflow = '';
      const s = store.get();
      if (!s || !s.done) store.set({ until: Date.now() + days * 864e5 });
      if (lastFocus) lastFocus.focus({ preventScroll: true });
    };
    root.addEventListener('click', (e) => { if (e.target.closest('[data-signup-close]')) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !root.hidden) close(); });

    const copy = root.querySelector('[data-signup-copy]');
    if (copy) copy.addEventListener('click', async () => {
      const code = root.querySelector('[data-signup-code]').textContent.trim();
      try { await navigator.clipboard.writeText(code); copy.textContent = copy.dataset.copied; } catch (e) {}
    });

    // Inscrição feita: guarda e mostra o cupom (a página volta com o formulário enviado)
    if (root.querySelector('[data-signup-done]')) {
      store.set({ done: true });
      open();
      return;
    }
    if (root.hasAttribute('data-design')) return;
    const s = store.get();
    if (s && (s.done || (s.until && s.until > Date.now()))) return;
    // Erro de e-mail na volta do envio: reabre para corrigir
    if (root.querySelector('.signup__err:not(:empty)')) { open(); return; }

    const delay = Number(root.dataset.delay || 15) * 1000;
    const timer = setTimeout(open, delay);
    const onScroll = () => {
      const h = document.documentElement;
      if (h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight) > 0.5) {
        clearTimeout(timer); window.removeEventListener('scroll', onScroll); open();
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
